import { gql } from "@apollo/client";

const getChatSessionsForAssessmentQuery = gql`
  query getChatSessionsForAssessmentQuery($assessmentId: Int!) {
    assessment(assessmentId: $assessmentId) {
      id
      suggestedAnswersState
    }
    chatSessions(assessmentId: $assessmentId) {
      edges {
        node {
          id
          assessmentQuestionId
        }
      }
    }
  }
`;

export default getChatSessionsForAssessmentQuery;
